export { CloseModal } from './CloseModal';
export { Link } from './Link';
export { OfferCheckout } from './OfferCheckout';
export { ShowFriendbuyWidget } from './ShowFriendbuyWidget';
export { ShowModal } from './ShowModal';

export const ACTIONS = {
  CLOSE_MODAL: 'CloseModal',
  LINK: 'Link',
  OFFER_CHECKOUT: 'OfferCheckout',
  SHOW_FRIENDBUY_WIDGET: 'ShowFriendbuyWidget',
  SHOW_MODAL: 'ShowModal',
};
